/* eslint-disable camelcase */
// EXCEPCIÓN TEMPORAL - ¡NO REPLICAR ESTE PATRÓN DE DESACTIVAR EL ESLINT!

import React, { useState, useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import {
  Box,
  Paper,
  Grid,
  TextField,
  Autocomplete,
  Typography,
  IconButton,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import SaveIcon from "@mui/icons-material/Save"
import DeleteIcon from "@mui/icons-material/Delete"
import PostAddIcon from "@mui/icons-material/PostAdd"
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera"
import Header from "../../../layouts/Header"
import BackIcon from "../../../components/BackIcon"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { useMutation, useQuery, api, showWarning, showSuccess } from "../../../api"
import { GlobalContext } from "../../../contexts/GlobalContext"
import ModalActivosPendientes from "./ModalActivosPendientes"

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const incrementarSerie = (serie) => {
  return serie.replace(/(\d+)(?!.*\d)/, (match) => (parseInt(match) + 1).toString().padStart(match.length, "0"))
}

const CrearAltasPPE = () => {
  const navigate = useNavigate()
  const [cabecera, setCabecera] = useState({
    observacion: "",
    procodigo: null,
    proruc: "",
    factura_obj: null,
    factotal: 0,
    ordencompra_id: "",
  })
  const [detalles, setDetalles] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [facturasList, setFacturasList] = useState([])
  const [catalogos, setCatalogos] = useState({ UBICACION: [], CUSTODIO: [], CENCOS: [], EMPLAZAMIENTO: [] })

  const [isReplicating, setIsReplicating] = useState(false)

  const extractor = (res) => {
    const d = res?.data || res
    const ex = (o) => (Array.isArray(o) ? (o.length === 2 && o[1] === 200 ? ex(o[0]) : o) : o?.data ? ex(o.data) : [])
    return ex(d)
  }

  useEffect(() => {
    const load = async () => {
      const types = ["UBICACION", "CUSTODIO", "CENCOS", "EMPLAZAMIENTO"]
      const results = await Promise.all(types.map((t) => api.post("/AltasPPE/getCatalogosAltas", { tipo: t })))
      const newCats = {}
      types.forEach((t, i) => (newCats[t] = extractor(results[i])))
      setCatalogos(newCats)
    }
    load()
  }, [])

  const { data: provs } = useQuery({
    queryKey: ["getProveedoresAprobados_Altas"],
    queryFn: async () => extractor(await api.get("/AltasPPE/getProveedoresAprobados")),
  })

  const { mutateAsync: saveAlta, isPending: isSaving } = useMutation({
    mutationFn: async () => {
      const payload = {
        cabecera: {
          ...cabecera,
          proruc: cabecera.proruc,
          facsecuen: cabecera.factura_obj?.facsecuen || "",
          facfeccad: cabecera.factura_obj?.facfeccad || null,
          facfecemi: cabecera.factura_obj?.facfecemi || null,
          factipo: cabecera.factura_obj?.factipo || "1",
        },
        detalles,
      }
      return api.post("/AltasPPE/createAltaActivos", payload)
    },
    onSuccess: () => {
      showSuccess("Alta Procesada Correctamente")
      navigate(-1)
    },
  })

  const handleImageUpload = (event, index) => {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        const nd = [...detalles]
        nd[index].imagen_base64 = reader.result
        setDetalles(nd)
      }
      reader.readAsDataURL(file)
    }
  }

  const replicarValor = (index, field, value) => {
    if (index >= detalles.length - 1 || isReplicating) return

    setIsReplicating(true)
    setTimeout(() => {
      if (window.confirm("¿Desea replicar este valor en los registros inferiores?")) {
        const nd = [...detalles]
        for (let i = index + 1; i < nd.length; i++) {
          nd[i][field] = value
          if (field === "emplazamiento_obj") {
            nd[i].emplcodigo = value?.id
            nd[i].centcodigo = value?.centcodigo
            nd[i].coscodigo = value?.centcodigo
          }
        }
        setDetalles(nd)
      }
      setIsReplicating(false)
    }, 100)
  }

  const aplicarSerieSecuencial = (index, value) => {
    if (!value || index >= detalles.length - 1 || isReplicating) return

    setIsReplicating(true)
    setTimeout(() => {
      if (window.confirm("¿Desea generar series secuenciales hacia abajo?")) {
        const nd = [...detalles]
        let s = value
        for (let i = index + 1; i < nd.length; i++) {
          s = incrementarSerie(s)
          nd[i].serie = s
        }
        setDetalles(nd)
      }
      setIsReplicating(false)
    }, 100)
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <Box sx={{ p: 4, backgroundColor: "#f5f7fa", minHeight: "100vh" }}>
        <BackIcon />
        <Box sx={{ mb: 3, display: "flex", justifyContent: "space-between" }}>
          <IconButton onClick={() => saveAlta()} disabled={isSaving} sx={{ backgroundColor: "white" }}>
            <SaveIcon color="primary" />
          </IconButton>
          <Typography variant="h5" fontWeight="bold">
            Alta de PPE
          </Typography>
          <Box width={40} />
        </Box>

        <Paper sx={{ p: 3, mb: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Observación"
                value={cabecera.observacion}
                onChange={(e) => setCabecera({ ...cabecera, observacion: e.target.value.toUpperCase() })}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={provs || []}
                getOptionLabel={(o) => `${o.procodigo} - ${o.pronombre}`}
                onChange={(e, v) => {
                  setCabecera({ ...cabecera, procodigo: v?.procodigo, proruc: v?.proruc })
                  if (v)
                    api
                      .post("/AltasPPE/getFacturasPendientes", { procodigo: v.procodigo })
                      .then((r) => setFacturasList(extractor(r)))
                }}
                renderInput={(p) => <TextField {...p} label="Proveedor" />}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={facturasList}
                getOptionLabel={(o) => `${o.facnumero} ($${o.facsubtot})`}
                onChange={(e, v) => setCabecera({ ...cabecera, factura_obj: v, ordencompra_id: v?.cocid || "" })}
                renderInput={(p) => <TextField {...p} label="Factura" />}
              />
            </Grid>
          </Grid>
        </Paper>

        <Paper sx={{ p: 3 }}>
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography variant="subtitle1" fontWeight="bold">
              Activos
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<PostAddIcon />}
              onClick={() => setModalOpen(true)}
              disabled={!cabecera.ordencompra_id}
            >
              Importar OC
            </Button>
          </Box>
          <TableContainer>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>SubTipo</b>
                  </TableCell>
                  <TableCell>
                    <b>Descripción</b>
                  </TableCell>
                  <TableCell>
                    <b>Marca</b>
                  </TableCell>
                  <TableCell>
                    <b>Modelo</b>
                  </TableCell>
                  <TableCell>
                    <b>Serie</b>
                  </TableCell>
                  <TableCell>
                    <b>Ubicación</b>
                  </TableCell>
                  <TableCell>
                    <b>Custodio</b>
                  </TableCell>
                  <TableCell>
                    <b>Emplazamiento</b>
                  </TableCell>
                  <TableCell>
                    <b>Cen. Costo</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>Foto</b>
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {detalles.map((row, idx) => (
                  <TableRow key={row.fila_id}>
                    <TableCell>
                      <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        {row.gendescri}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        fullWidth
                        value={row.artdescripcion}
                        onChange={(e) => {
                          const nd = [...detalles]
                          nd[idx].artdescripcion = e.target.value.toUpperCase()
                          setDetalles(nd)
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        value={row.marca}
                        onChange={(e) => {
                          const nd = [...detalles]
                          nd[idx].marca = e.target.value.toUpperCase()
                          setDetalles(nd)
                        }}
                        onBlur={(e) => replicarValor(idx, "marca", e.target.value)}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        value={row.modelo}
                        onChange={(e) => {
                          const nd = [...detalles]
                          nd[idx].modelo = e.target.value.toUpperCase()
                          setDetalles(nd)
                        }}
                        onBlur={(e) => replicarValor(idx, "modelo", e.target.value)}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        value={row.serie}
                        onChange={(e) => {
                          const nd = [...detalles]
                          nd[idx].serie = e.target.value.toUpperCase()
                          setDetalles(nd)
                        }}
                        onBlur={(e) => aplicarSerieSecuencial(idx, e.target.value)}
                      />
                    </TableCell>
                    <TableCell>
                      <Autocomplete
                        size="small"
                        options={catalogos.UBICACION}
                        value={catalogos.UBICACION.find((u) => u.id === row.ubicodigo) || null}
                        onChange={(e, v) => {
                          const nd = [...detalles]
                          nd[idx].ubicodigo = v?.id
                          setDetalles(nd)
                          replicarValor(idx, "ubicodigo", v?.id)
                        }}
                        renderInput={(p) => <TextField {...p} />}
                      />
                    </TableCell>
                    <TableCell>
                      <Autocomplete
                        size="small"
                        options={catalogos.CUSTODIO}
                        value={catalogos.CUSTODIO.find((c) => c.id === row.emcodemp) || null}
                        onChange={(e, v) => {
                          const nd = [...detalles]
                          nd[idx].emcodemp = v?.id
                          setDetalles(nd)
                          replicarValor(idx, "emcodemp", v?.id)
                        }}
                        renderInput={(p) => <TextField {...p} />}
                      />
                    </TableCell>
                    {/* Emplazamiento restaurado - Vital para obtener 'centcodigo' */}
                    <TableCell>
                      <Autocomplete
                        size="small"
                        options={catalogos.EMPLAZAMIENTO}
                        value={row.emplazamiento_obj || null}
                        onChange={(e, v) => {
                          const nd = [...detalles]
                          nd[idx].emplazamiento_obj = v
                          nd[idx].emplcodigo = v?.id
                          nd[idx].centcodigo = v?.centcodigo
                          setDetalles(nd)
                          replicarValor(idx, "emplazamiento_obj", v)
                        }}
                        renderInput={(p) => <TextField {...p} />}
                      />
                    </TableCell>
                    <TableCell>
                      <Autocomplete
                        size="small"
                        options={catalogos.CENCOS}
                        value={catalogos.CENCOS.find((cc) => cc.id === row.coscodigo) || null}
                        onChange={(e, v) => {
                          const nd = [...detalles]
                          nd[idx].coscodigo = v?.id
                          setDetalles(nd)
                          replicarValor(idx, "coscodigo", v?.id)
                        }}
                        renderInput={(p) => <TextField {...p} />}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <input
                        accept="image/*"
                        style={{ display: "none" }}
                        id={`img-${idx}`}
                        type="file"
                        onChange={(e) => handleImageUpload(e, idx)}
                      />
                      <label htmlFor={`img-${idx}`}>
                        <IconButton color={row.imagen_base64 ? "secondary" : "default"} component="span">
                          <PhotoCameraIcon />
                        </IconButton>
                      </label>
                    </TableCell>
                    <TableCell>
                      <IconButton onClick={() => setDetalles(detalles.filter((_, i) => i !== idx))}>
                        <DeleteIcon color="error" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <ModalActivosPendientes
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          cocid={cabecera.ordencompra_id}
          onActivosSeleccionados={(n) => setDetalles([...detalles, ...n])}
        />
      </Box>
    </ThemeProvider>
  )
}
export default CrearAltasPPE
